export class Receita {
  tipo: string;
  valor: number;
  dataReferencia: Date;

  orNull() {
    if ((this.tipo == null || this.tipo == 'null') && (this.valor == null) && (this.dataReferencia == null)) {
      return null;
    } else {
      return this;
    }
  }
}
